import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface DashedSeperatorStyles {
    seperatorStyles?: InjectableCss;
}

export const dashedSeperatorStyles: DashedSeperatorStyles = {
    seperatorStyles: {
        css: css`
            background-image: linear-gradient(to right, #BDBBBD 80%, rgba(255, 255, 255, 0) 50%);
            background-position: top;
            background-size: 38px 1px;
            background-repeat: repeat-x;
            height: 1px;
            margin: 0 auto;
            width: 50%;
            padding-bottom: 104px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            padding-bottom: 56px;
                        `,
                        css`
                            width: 100%;
                            padding-bottom: 56px;
                        `,
                        css`
                            padding-bottom: 78px;
                        `,
                        null,
                    ],
                );
            }}
        }
        `,
    },
};

type Props = WidgetProps;

const DashedSeperator: React.FC<Props> = () => {
    const styles = dashedSeperatorStyles;

    return (
        <StyledWrapper {...styles.seperatorStyles}></StyledWrapper>
    );
};

const dashedSeperator: WidgetModule = {
    component: DashedSeperator,
    definition: {
        group: "Common",
        fieldDefinitions: [],
    },
};

export default dashedSeperator;
